import { render, staticRenderFns } from "./matriciel.vue?vue&type=template&id=544fe4c6&scoped=true&"
import script from "./matriciel.vue?vue&type=script&lang=js&"
export * from "./matriciel.vue?vue&type=script&lang=js&"
import style0 from "./matriciel.vue?vue&type=style&index=0&id=544fe4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544fe4c6",
  null
  
)

export default component.exports